import React, { useReducer, useState } from 'react';
import { FormWrapper } from './../../elements/ContactElements';

const ContactForm = () => {

    const [state, dispatch] = useReducer((state, action) => {
        switch(action.type){
            case "ADD_NAME":
                return { ...state, name: action.value}
            case "ADD_EMAIL":
                return { ...state, email: action.value} 
            case "ADD_SUBJECT":
                return { ...state, subject: action.value} 
            case "ADD_MESSAGE":
                return { ...state, message: action.value}
            case "RESET_FORM":
                return {
                    name: "",
                    email: "",
                    subject: "",
                    message: "" 
                }
            default:
                return state
        }
    },{
        name: "",
        email: "",
        subject: "",
        message: ""

    })

    const [status, setStatus] = useState("")

    const onFormSubmit = (evt) => {

        evt.preventDefault();
        const form = evt.target;
        const data = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.open(form.method, form.action);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;
            if (xhr.status === 200) {
                form.reset();
                setStatus("success")
                dispatch({type: "RESET_FORM"})
            }else{
                setStatus("fail")
            }
        };
        xhr.send(data);
        
    }

    return (
        <FormWrapper>
            <div className="container">
                <h2>Write To <span className="effect">Us</span></h2>
                <p>* All fields are required *</p>
                <form 
                    action="https://formspree.io/mzbjkbro"
                    method="POST"
                    onSubmit={onFormSubmit}
                    autoComplete="new-password"
                >
                    <div className="form-block">
                        <input type="text" placeholder="Full Name" autoComplete="new-password" name="name" 
                            value={state.name}
                            required={true}
                            onChange={ 
                            (e) => {
                                dispatch({ type: "ADD_NAME", value: e.target.value })
                            }
                        } />
                    </div>
                    <div className="form-block">
                        <input type="email" autoComplete="new-password" placeholder="Email Address" name="email" 
                            value={state.email}
                            required={true}
                            onChange={ 
                            (e) => {
                                dispatch({ type: "ADD_EMAIL", value: e.target.value })
                            }
                        }/> 
                    </div>
                    <div className="form-block">
                        <input type="text" autoComplete="new-password" placeholder="Subject" name="subject" 
                        required={true}
                        value={state.subject}
                        onChange={ 
                            (e) => {
                                dispatch({ type: "ADD_SUBJECT", value: e.target.value })
                            }
                        }/> 
                    </div>
                    <div className="form-block">
                        <textarea placeholder="Message" autoComplete="new-password" name="message"
                        value={state.message}
                        required={true}
                        onChange={ 
                            (e) => {
                                dispatch({ type: "ADD_MESSAGE", value: e.target.value })
                            }
                        }
                        >
                        
                        </textarea>
                    </div>
                    <div className="form-block">
                        <button 
                            type="submit" 
                            className="btn"
                        >
                            Send
                        </button>
                    </div>
                </form>
                { status && <div className={status}>{(status === "success") ? "Your form has been successfully submitted": "Something went wrong"}</div>}
            </div>
        </FormWrapper>
    )

}

export default ContactForm;